// extracted by mini-css-extract-plugin
export default {"headline":"InstructionPage_headline__Y3yyk"};